import Vue from 'vue'
import ddStringsPlugin from './dd-strings/dd-strings.plugin'

Vue.use(ddStringsPlugin)
